import { AxiosAuthLink, AxiosGet } from "../useApi";

const route = 'instances';

export function GetInstances() {
    return AxiosGet(route)
}

export function InstanceAuthLink(link) {
    return AxiosAuthLink(link)
}
